export const SIDE_NAVIGATION_RETRACTED_WITH = 5; //rem
export const SIDE_NAVIGATION_EXPANDED_WIDTH = 17; //rem
export const NAVBAR_ITEM_PADDING_VERTICAL = 0.7; //rem
export const NAVBAR_ITEM_PADDING_HORIZONTAL = 1; //rem
export const NAVBAR_ITEM_ICON_WIDTH = 1.5; //rem
export const TOP_NAVBAR_HEIGHT = 5; //rem
export const PROFILE_AVATAR_SIZE = 6; //rem